import { render, staticRenderFns } from "./ImageExamsSection.vue?vue&type=template&id=5d9870e0&scoped=true&"
import script from "./ImageExamsSection.vue?vue&type=script&lang=js&"
export * from "./ImageExamsSection.vue?vue&type=script&lang=js&"
import style0 from "./ImageExamsSection.vue?vue&type=style&index=0&id=5d9870e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9870e0",
  null
  
)

export default component.exports